<template>
  <div id="eclass">
    <bread :content="breadContent"></bread>
    <div id="class-router">
      <p class="Page-title">在线微课</p>
      <p class="router-go" @click="$router.push({name:'onlineClass'})">应急视频</p>
      <p class="router-go" @click="$router.push({name:'lectures'})">应急讲座</p>
    </div>
    <el-divider></el-divider>
    <p class="title">精选视频</p>
    <div class="video">
      <video-card v-for="(item,index) in videoData" :key="index" :imgHeight="'150px'" :videoData="item"></video-card>
    </div>
    <p class="title">全部视频</p>
    <div class="video">
      <video-card class="allvideo" v-for="(item,index) in allvideoData" :key="index" :imgHeight="'120px'" :videoData="item"></video-card>
    </div>
    <el-pagination class="page" background layout="prev, pager, next,jumper" :total="allvideoData.length" :page-size="12" @current-change="handleCurrentChange" :current-page="tableIndex">
    </el-pagination>
  </div>
</template>
<script>
import bread from "@/components/bread";
import videoCard from "@/components/emrclass/videoCard";
import Api from "@/network.js";
export default {
  name: "eclass",
  components: {
    bread,
    videoCard
  },
  async beforeRouteEnter(to, from, next) {
    let res = await Api.emrClass.getVideo("yjkt");
    next(vm => {
      vm.videoData = res.RecommendVideos;
      vm.tableData = res.AllVideos;
    });
  },
  data() {
    return {
      breadContent: [
        { text: "应急课堂", routerName: "emrClass" },
        { text: "在线微课", routerName: "emrClass" }
      ],
      tableData: [],
      videoData: [],
      allvideoData: [],
      tableIndex: 1
    };
  },
  methods: {
    handleCurrentChange(index) {
      this.tableData = this.allvideoData.slice((index - 1) * 12, index * 12);
    }
  }
};
</script>
<style lang="scss" scoped>
#eclass {
  display: block;
  width: calc(100% - 250px);
  margin-left: 50px;
  margin-top: 40px;
}
#class-router {
  display: flex;
  align-items: flex-end;
  p {
    margin-right: 20px;
  }
  .router-go {
    font-size: 20px;
  }
}
.title {
  font-size: 28px;
  margin-bottom: 15px;
}
.videoCard {
  width: 320px;
  margin-bottom: 35px;
  margin-right: 2%;
}
.video {
  display: flex;
  flex-wrap: wrap;
}
.allvideo {
  width: 228px;
}
.page {
  width: 100%;
  transform: scale(1.3);
  text-align: center;
  margin-top: 50px;
}
</style>

